import { httpClient } from '@/services/http/httpClient'

import type { ScoreParameters } from '../types'

type ScoreHttpResponse = {
  id: string
  parameter: string
  value: string
}

type ScoresHttpResponse = ScoreHttpResponse[]

export type Score = {
  [key in ScoreParameters]?: number
}

export async function getScores(): Promise<Score> {
  const parametersMap: Record<string, ScoreParameters> = {
    idea_creation_weight: 'ideaCreationWeight',
    idea_select_weight: 'ideaSelectWeight',
    idea_co_creation_weight: 'ideaCoCreationWeight',
    idea_implement_weight: 'ideaImplementWeight',
    idea_comment_weight: 'ideaCommentWeight',
  }

  const { data: scoresResponse = [] } =
    await httpClient.get<ScoresHttpResponse>('/tennants/configs/points')

  const scores = scoresResponse.reduce<Score>((acc, score) => {
    const parameter = parametersMap[score.parameter]

    if (!parameter) {
      return acc
    }

    return {
      ...acc,
      [parameter]: Number(score.value),
    }
  }, {} as Score)

  return scores
}
